import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { BusinessAccountRequestService } from '../services';
import { BUSINESS_ACCOUNT_REQUEST_LIST_KEY } from '../constants';

const useRejectBusinessAccountRequest = (id: string, onSuccess?: () => void) => {
  const { t } = useTranslation('businessAccountRequest');
  const queryClient = useQueryClient();

  return useMutation((rejectionReason: string) => BusinessAccountRequestService.reject(id, rejectionReason), {
    onSuccess: () => {
      toast.success(t('successRejected'));
      queryClient.invalidateQueries({ queryKey: [BUSINESS_ACCOUNT_REQUEST_LIST_KEY] });
      onSuccess?.();
    },
  });
};

export default useRejectBusinessAccountRequest;
